<!-- <div *ngIf="loading">
    <div class="centered-container">
        <div class="centered-content">
            <app-loader></app-loader>
          <p>Authenticating, please wait...</p>
        </div>
      </div>
      
</div> -->
<div  class="redirecting-screen">

  <!-- <div class="redirecting-content">
    <app-loader></app-loader>
    <img class="ososLogo" src="../../../assets/images/Osos/osos_logo_sis.svg" alt="">
    <h3>Authenticating... Please wait</h3>
  </div> -->
  <div class="redirecting-content animated-redirect">

    <img class="ososLogo fade-in-logo" src="../../../assets/images/Osos/osos_logo_sis.svg" alt="">
    <h3 class="typing-dots">Authenticating Please Wait<span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></h3>
  </div> 
</div>
